import { observable, action, reaction } from 'mobx'
import { fetchUsers, User } from 'pages/Home/Test/mockUsersApi'
import orgs from 'store/orgs.store'

class ImsUsersStore {
  constructor() {
    reaction(
      () => orgs.currentOrgId,
      id => {
        if (id) {
          this.load(id)
        }
      }
    )
  }

  @observable allUsers: User[] = []
  @observable users: User[] = []
  @observable totalCount = 0
  @observable loading = false

  @action load = async (communityId: number) => {
    this.loading = true
    const res = await fetchUsers(communityId)
    this.allUsers = res.data
    this.users = res.data
    this.totalCount = res.total
    this.loading = false
  }

  @action filterUsers = (search: string, page: number, pageSize: number) => {
    const filtered = search.length >= 2
      ? this.allUsers.filter(u => {
          const s = search.toLowerCase()
          return (u as any).fullName?.toLowerCase().includes(s)
            || (u as any).nickname?.toLowerCase().includes(s)
            || (u as any).israelId?.toLowerCase().includes(s)
            || (u as any).mainMobilePhone?.toLowerCase().includes(s)
            || (u as any).email?.toLowerCase().includes(s)
        })
      : this.allUsers
    this.totalCount = filtered.length
    this.users = filtered.slice(page * pageSize, page * pageSize + pageSize)
  }

  @action removeUser = (userId: number) => {
    this.users = this.users.filter((u: any) => (u.userId ?? u.id) !== userId)
  }
}

const imsUsersStore = new ImsUsersStore()
export default imsUsersStore
